import { render, staticRenderFns } from "./accountSidebar.vue?vue&type=template&id=5a22d3aa&scoped=true"
import script from "./accountSidebar.vue?vue&type=script&lang=js"
export * from "./accountSidebar.vue?vue&type=script&lang=js"
import style0 from "./accountSidebar.vue?vue&type=style&index=0&id=5a22d3aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22d3aa",
  null
  
)

export default component.exports